import React from 'react';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';

import img1Alt from '../../assets/frames/wrkat-extraimg1@2x-min.png';
import img2Alt from '../../assets/frames/wrkat-extraimg2@2x-min.png';
import img3Alt from '../../assets/frames/wrkat-extraimg3@2x-min.png';


import env1Image from '../../assets/envImages/wrkat-env1-min.jpg';
import env2Image from '../../assets/envImages/wrkat-env2-min.jpg';
import footerBanner from '../../assets/envImages/wrkat-footerBanner.jpg';
import hero from '../../assets/hero/wrkat-hero@2x-min.jpg';

export default {
  path: '/cases/wrkat',
  color: variables.wrkatPrimary,
  hero: { fall: hero },
  xtra: [
    { fall: img1Alt },
    { fall: img2Alt },
    { fall: img3Alt },
  ],
  environments: { env1: env1Image, env2: env2Image },
  footerBanner: { fall: footerBanner },
  title: 'Wrkat',
  titleBodyData: {
    0: {
      title: 'Co-working, whenever, wherever',
      body: 'Wrkat is the platform that gives you access to co-working spaces all across the world. One membership, international access.',
    },
    1: {
      title: 'Your smartphone, the key to business',
      body: 'Your smartphone is the new key to business. Whether as a door key, or as a conversation opener for meeting like-minded future business partners.',
    },
  },
  quoteData: {
    quote: 'We got referred to We app from a mutual partner, who were satisfied with the high standards of We app\'s work. Looking back, we are very happy for that reference, now that we can see the awesome service they helped us build. ',
    name: 'Suad Januzzi',
    profession: 'Co-Founder & CEO, Wrkat AB',
  },
  sideHeadingFirst: 'iOS & Android application',
  sideHeadingSecond: 'Developed in React Native',
  infoTitle: 'What we built',
  infoBody:
  <span>
    We App partnered up with Wrkat and built all the features enabling this powerful ecosystem. Both an elegant and converting homepage. And a mobile app that connects users to all co-working spaces, serves as an access key to these, and promotes networking.
    <br />
    <br />
    The mobile app was built in
    {' '}
    <Highlight>React Native.</Highlight>
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
};
